"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var KnockoutBoundProperty = /** @class */ (function () {
    function KnockoutBoundProperty(observable, onChange) {
        var _this = this;
        this.observable = observable;
        this.onChange = onChange;
        this.subscription = this.observable.subscribe(function (newValue) {
            if (_this.isUpdatingKo) {
                return;
            }
            _this.isUpdatingReact = true;
            _this.onChange(newValue);
            _this.isUpdatingReact = false;
        });
    }
    KnockoutBoundProperty.prototype.update = function (value) {
        if (this.isUpdatingReact) {
            return;
        }
        this.isUpdatingKo = true;
        this.observable(value);
        this.isUpdatingKo = false;
    };
    KnockoutBoundProperty.prototype.dispose = function () {
        this.subscription.dispose();
    };
    return KnockoutBoundProperty;
}());
exports.KnockoutBoundProperty = KnockoutBoundProperty;
